import * as React from "react";
import classNames from "classnames";

interface ITabContentContainerProps {
    className?: string;
}

const TabContentContainer: React.SFC<ITabContentContainerProps> = props => {
    const rootClasses = classNames("tab-content-container", props.className);
    return <div className={rootClasses}>{props.children}</div>;
};

export default TabContentContainer;
